import React from 'react'
import PropTypes from 'prop-types';
import { useLocalisation } from '@3plearning/lingui-cdn';

import * as styled from './styled'
import getTranslations from './translations'

const AssignmentsSummary = ({currentlyAssignedAssignmentsCount, totalAssignments}) => {
  const { i18n } = useLocalisation();

  const {CURRENTLY_ASSIGNED, OVERDUE, TOTAL_ASSIGNMENTS} = getTranslations({i18n});
  return (
    <styled.Wrapper>
      <styled.SummaryRow>
        {CURRENTLY_ASSIGNED}: <styled.Count>{currentlyAssignedAssignmentsCount}</styled.Count>
      </styled.SummaryRow>
      <styled.SummaryRow>
        {OVERDUE}: <styled.Count>{totalAssignments -currentlyAssignedAssignmentsCount}</styled.Count>
      </styled.SummaryRow>
      <styled.SummaryRow>
        {TOTAL_ASSIGNMENTS}:<styled.Count>{totalAssignments}</styled.Count>
      </styled.SummaryRow>
    </styled.Wrapper>
  )
}

AssignmentsSummary.propTypes = {
  currentlyAssignedAssignmentsCount: PropTypes.number.isRequired,
  totalAssignments: PropTypes.number.isRequired
}

export default AssignmentsSummary;